module.exports = __webpack_public_path__ + "static/media/land_transfer.97d383d6.svg";